module.exports = __webpack_public_path__ + "img/block12.5270b78d.png";